module.exports = __webpack_public_path__ + "img/h_perfil.91a719e0.png";